var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "256",
      "height": "257",
      "viewBox": "0 0 256 257",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_632_47185)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.999 20.8801C68.6104 20.8801 20.4639 69.0271 20.4639 128.417C20.4639 187.805 68.6104 235.951 127.999 235.951C187.388 235.951 235.535 187.805 235.535 128.417C235.535 69.0271 187.388 20.8801 127.999 20.8801Z",
      "fill": "#C4FEFA"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.999 0.916016C57.6955 0.916016 0.5 58.112 0.5 128.417C0.5 198.721 57.6955 255.916 127.999 255.916C198.303 255.916 255.5 198.721 255.5 128.417C255.5 58.112 198.303 0.916016 127.999 0.916016ZM127.999 251.832C59.948 251.832 4.5845 196.468 4.5845 128.417C4.5845 60.365 59.948 5.00002 127.999 5.00002C196.051 5.00002 251.415 60.3645 251.415 128.417C251.415 196.468 196.051 251.832 127.999 251.832Z",
      "fill": "#ADFBF6"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.6298 135.074L69.7143 135.333L68.6298 135.592C62.2883 137.114 57.3383 141.858 55.7453 147.931L55.4738 148.968L55.2048 147.931C53.6133 141.858 48.6608 137.114 42.3173 135.592L41.2373 135.333L42.3173 135.074C48.6613 133.552 53.6133 128.807 55.2048 122.735L55.4738 121.697L55.7453 122.735C57.3388 128.807 62.2883 133.552 68.6298 135.074Z",
      "fill": "#ADFBF6"
    }
  }), _c('path', {
    attrs: {
      "d": "M219.805 100.959L221.439 101.348L219.805 101.739C210.252 104.031 202.796 111.177 200.397 120.325L199.987 121.887L199.582 120.325C197.184 111.177 189.724 104.031 180.169 101.739L178.542 101.348L180.169 100.959C189.725 98.6656 197.185 91.5181 199.582 82.3721L199.987 80.8086L200.397 82.3721C202.796 91.5181 210.252 98.6661 219.805 100.959Z",
      "fill": "#59C8C1"
    }
  }), _c('path', {
    attrs: {
      "d": "M170.725 80.6195L171.487 80.809L170.725 80.999C166.278 82.1135 162.805 85.5875 161.688 90.036L161.498 90.795L161.309 90.036C160.193 85.587 156.719 82.113 152.269 80.999L151.512 80.809L152.269 80.6195C156.719 79.5045 160.193 76.029 161.309 71.5815L161.498 70.822L161.688 71.5815C162.805 76.029 166.278 79.5045 170.725 80.6195Z",
      "fill": "#59C8C1"
    }
  }), _c('path', {
    attrs: {
      "d": "M128.001 50.0659L145.817 165.098L194.679 177.655L128.001 50.0659Z",
      "fill": "#59C8C1"
    }
  }), _c('path', {
    attrs: {
      "d": "M128.001 50.0659V177.836L145.817 165.098L128.001 50.0659Z",
      "fill": "#61D7CF"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.999 50.0659L110.183 165.098L61.3203 177.655L127.999 50.0659Z",
      "fill": "#61D7CF"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.999 50.0659V177.836L110.183 165.098L127.999 50.0659Z",
      "fill": "#59C8C1"
    }
  }), _c('path', {
    attrs: {
      "d": "M128.001 202.057C126.62 202.057 125.501 200.937 125.501 199.557V184.419C125.501 183.038 126.62 181.919 128.001 181.919C129.381 181.919 130.501 183.038 130.501 184.419V199.557C130.501 200.937 129.381 202.057 128.001 202.057Z",
      "fill": "#80E9E2"
    }
  }), _c('path', {
    attrs: {
      "d": "M109.979 209.266C108.598 209.266 107.479 208.146 107.479 206.766V184.419C107.479 183.038 108.598 181.919 109.979 181.919C111.359 181.919 112.479 183.038 112.479 184.419V206.766C112.479 208.146 111.36 209.266 109.979 209.266Z",
      "fill": "#80E9E2"
    }
  }), _c('path', {
    attrs: {
      "d": "M146.022 209.266C144.642 209.266 143.522 208.146 143.522 206.766V184.419C143.522 183.038 144.642 181.919 146.022 181.919C147.403 181.919 148.522 183.038 148.522 184.419V206.766C148.522 208.146 147.403 209.266 146.022 209.266Z",
      "fill": "#80E9E2"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_632_47185"
    }
  }, [_c('rect', {
    attrs: {
      "width": "256",
      "height": "256",
      "fill": "white",
      "transform": "translate(0 0.416016)"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }